import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { resolveSubdomainFromUrl } from '../lib/resolveShop';
import ShopHome from './ShopHome';

/**
 * Decides what `/` should render:
 *  - On a real shop subdomain hostname (e.g. sharpandsons.instacut.co.uk)
 *    OR with ?shop=… in the query → render the public ShopHome landing.
 *  - Otherwise (back-office hosts: app.instacut.co.uk, localhost, preview)
 *    → keep the existing redirect into /dashboard.
 */
const RootGate = () => {
  const location = useLocation();
  const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
  const subdomain = resolveSubdomainFromUrl({
    hostname,
    pathname: location.pathname,
    search: location.search,
  });
  if (subdomain) return <ShopHome />;
  return <Navigate to="/dashboard" replace />;
};

export default RootGate;
